import React, { useState } from 'react';

import Control from 'components/Control';

const MouseMove = ({ onClickAdd, onClickSplit, children, viewOnly, showControlMenu = true }) => {
  const [position, setPosition] = useState(0);

  const onMouseMove = (event) => {
    const { top } = event.currentTarget.getBoundingClientRect();
    const y = event.clientY - top - 56;

    setPosition(y);
  };

  return (
    <>
      {showControlMenu && (
        <div className="absolute -right-25" style={{ top: position + 'px' }}>
          <Control viewOnly={viewOnly} onClickAdd={onClickAdd} onClickSplit={onClickSplit} />
        </div>
      )}
      <div onMouseMove={onMouseMove}>{children}</div>
    </>
  );
};

export default React.memo(MouseMove);
